import type { ReactNode } from 'react'
import { cn } from '@/shared/libs/cn'

interface PageContainerProps {
  children: ReactNode
  className?: string
}

export function PageContainer({ children, className }: PageContainerProps) {
  return <div className={cn('bg-white rounded-xl min-h-full p-6', className)}>{children}</div>
}
